package com.appcreator.client.firebase.appcheck

import com.appcreator.client.firebase.appcheck.externals.AppCheckOptions
import com.appcreator.client.firebase.appcheck.externals.ReCaptchaEnterpriseProvider
import com.appcreator.client.firebase.appcheck.externals.initializeAppCheck
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.app
import dev.gitlive.firebase.js
import kotlin.js.json

actual fun platformAppCheckInitialize(reCaptchaSiteKey: String) {

    val provider = ReCaptchaEnterpriseProvider(reCaptchaSiteKey)

    // Initialize AppCheck
    val appCheckOptions: AppCheckOptions = js("{}")
    appCheckOptions.provider = provider
    appCheckOptions.isTokenAutoRefreshEnabled = true
    val json = json(
        "provider" to provider,
        "isTokenAutoRefreshEnabled" to true
    )
    initializeAppCheck(Firebase.app.js, json)

    // TODO add app check header in JS
}